import React, { FC } from 'react';
import { create } from 'zustand';

export type CarouselVariants =
  | 'horizontal'
  | 'vertical'
  | 'stack'
  | 'dynamic'
  | 'grid';

export interface CarouselStore {
  index: number;
  total: number;
  variant: CarouselVariants;
  setIndex: (index: number) => void;
  setTotal: (total: number) => void;
  setVariant: (variant: CarouselVariants) => void;
  next: () => void;
  prev: () => void;
}

export const useCarouselStore = create<CarouselStore>((set, get) => ({
  index: 0,
  total: 0,
  variant: 'horizontal',
  setIndex: index => {
    set({ index });
  },
  setTotal: total => {
    if (total === get().total) return;
    set({ total });
  },
  setVariant: variant => {
    if (variant === get().variant) return;
    set({ variant });
  },
  next: () => set(s => ({ index: Math.min(s.total - 1, s.index + 1) })),
  prev: () => set(s => ({ index: Math.max(0, s.index - 1) }))
}));

export const CarouselProvider: FC = ({ children }) => {
  return <>{children}</>;
};
